import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { throttle, deepMix } from '@antv/util';
import { selectPlotArea, mousePosition } from './utils';
function maybeCoordinate(options) {
  var _options$coordinate = options.coordinate,
    coordinate = _options$coordinate === void 0 ? {} : _options$coordinate;
  var _coordinate$transform = coordinate.transform,
    transform = _coordinate$transform === void 0 ? [] : _coordinate$transform;
  var fisheye = transform.find(function (d) {
    return d.type === 'fisheye';
  });
  if (fisheye) return fisheye;
  var newFisheye = {
    type: 'fisheye'
  };
  transform.push(newFisheye);
  coordinate.transform = transform;
  options.coordinate = coordinate;
  return newFisheye;
}
/**
 * @todo Bind abstract data or data index.
 */
export function Fisheye(_ref) {
  var _ref$wait = _ref.wait,
    wait = _ref$wait === void 0 ? 30 : _ref$wait,
    leading = _ref.leading,
    _ref$trailing = _ref.trailing,
    trailing = _ref$trailing === void 0 ? false : _ref$trailing;
  return function (context) {
    var options = context.options,
      update = context.update,
      setState = context.setState,
      container = context.container;
    var plotArea = selectPlotArea(container);
    var updateFocus = throttle(function (event) {
      var focus = mousePosition(plotArea, event);
      if (!focus) {
        setState('fisheye');
        update();
        return;
      }
      setState('fisheye', function (options) {
        // Clone options and mutate it.
        // Disable animation.
        var clonedOptions = deepMix({}, options);
        var _iterator = _createForOfIteratorHelper(clonedOptions.marks),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mark = _step.value;
            mark.animate = false;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var _focus = _slicedToArray(focus, 2),
          x = _focus[0],
          y = _focus[1];
        var fisheye = maybeCoordinate(clonedOptions);
        fisheye.focusX = x;
        fisheye.focusY = y;
        fisheye.visual = true;
        return clonedOptions;
      });
      update();
    }, wait, {
      leading: leading,
      trailing: trailing
    });
    // Bind events.
    plotArea.addEventListener('pointerenter', updateFocus);
    plotArea.addEventListener('pointermove', updateFocus);
    plotArea.addEventListener('pointerleave', updateFocus);
    return function () {
      plotArea.removeEventListener('pointerenter', updateFocus);
      plotArea.removeEventListener('pointermove', updateFocus);
      plotArea.removeEventListener('pointerleave', updateFocus);
    };
  };
}